export default {"src":"/_next/static/media/apple.9de19a7b.svg","height":40,"width":165};